import { usePage } from '@inertiajs/react';
import { Header } from '@/theme1/components/layout/Header';
import { TopBar } from '@/theme1/components/layout/TopBar';
import { Footer } from '@/theme1/components/layout/Footer';

export default function StoreLayout({ children }) {
  const { frontendTheme } = usePage().props;

  return (
    <div
      className="min-h-screen bg-background text-foreground antialiased"
      data-frontend-theme={frontendTheme?.name ?? 'theme1'}
    >
      <TopBar />
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
